<template>
  <div
    :class="{'hide-for-print' : messages.length === 0}"
    class="pega-print-page-break"
    data-test="outer-div"
  >
    <div class="boss-layout-block-large hide-for-print">
      <accordion
        :is-open="true"
        head-class="pega-accordion-head-important"
      >
        <template #head>
          メッセージ作成
        </template>
        <template #body>
          <job-pre-published-preview-message-form @fetchMessages="fetchMessages" />
        </template>
      </accordion>
    </div>
    <div class="boss-layout-block-large">
      <accordion
        v-if="messages.length"
        :is-open="true"
        head-class="pega-accordion-head-important"
        data-test="message-history"
      >
        <template #head>
          メッセージ履歴
        </template>
        <template #body>
          <job-pre-published-preview-message-history :messages="messages" />
        </template>
      </accordion>
    </div>
  </div>
</template>

<script>
import Accordion from '@/components/atoms/Accordion'
import JobPrePublishedPreviewMessageForm from '@/components/molecules/JobPrePublishedPreviewMessageForm'
import JobPrePublishedPreviewMessageHistory from '@/components/molecules/JobPrePublishedPreviewMessageHistory'
import bossSCommon from '@/lib/bossSCommon'

export default {
  components: {
    Accordion,
    JobPrePublishedPreviewMessageForm,
    JobPrePublishedPreviewMessageHistory
  },
  mixins: [bossSCommon],
  data () {
    return { messages: [] }
  },
  created () {
    this.fetchMessages()
  },
  methods: {
    fetchMessages () {
      this.$http.secured.get(`${this.apiPath}/messages`).then((response) => {
        this.$set(this, 'messages', response.data)
      })
    }
  }
}
</script>
